import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';

import Pill from './Pill';
import RemixIcon from './RemixIcon';

const USPCardRow = ({
  icon,
  title,
  description,
  comingSoon = false,
  textClass,
  iconClass,
  ctaClass,
  ctaTo,
  cta,
}) => {
  return (
    <div className="my-4 md:flex md:items-start md:space-x-4">
      {icon && (
        <div
          className={classnames(
            'flex items-center justify-center h-10 w-10 rounded flex-shrink-0',
            iconClass
          )}
        >
          <RemixIcon icon={icon} />
        </div>
      )}

      <div className="w-full">
        {title && (
          <div
            className={classnames('my-4 md:mb-2 md:mt-0', {
              'flex flex-row items-baseline justify-start': comingSoon,
            })}
          >
            <h5 className="font-semibold leading-5">{title}</h5>
            {comingSoon && <Pill label="Soon" size="small" className="ml-4" />}
          </div>
        )}

        {description && (
          <p className={classnames('leading-6 text-sm', textClass)}>
            {description}
          </p>
        )}

        {ctaTo && (
          <div className="pt-6">
            <Link
              to={ctaTo}
              className={classnames('font-medium group', ctaClass)}
            >
              {cta || 'Learn more'}
              <span className="duration-100 group-hover:translate-x-1 inline-block ml-1 transform transition-transform">
                &#8594;
              </span>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

const USPCardColumn = ({
  icon,
  title,
  description,
  comingSoon = false,
  iconClass,
  textClass,
  ctaClass,
  ctaTo,
  cta,
}) => {
  return (
    <div className="my-4">
      {icon && (
        <div
          className={classnames(
            'flex items-center justify-center h-10 w-10 rounded',
            iconClass
          )}
        >
          <RemixIcon icon={icon} />
        </div>
      )}

      <div>
        {title && (
          <div
            className={classnames('my-4', {
              'flex flex-row items-baseline justify-start': comingSoon,
            })}
          >
            <h5 className="font-semibold leading-5">{title}</h5>
            {comingSoon && <Pill label="Soon" size="small" className="ml-4" />}
          </div>
        )}

        {description && (
          <p className={classnames('leading-6 text-sm', textClass)}>
            {description}
          </p>
        )}

        {ctaTo && (
          <div className="pt-6">
            <Link
              to={ctaTo}
              className={classnames('font-medium group', ctaClass)}
            >
              {cta || 'Learn more'}
              <span className="duration-100 group-hover:translate-x-1 inline-block ml-1 transform transition-transform">
                &#8594;
              </span>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

const USPCardRedesigned = ({
  direction = 'column',
  theme = 'default',
  ...props
}) => {
  const textClass = (theme) => {
    switch (theme) {
      case 'haiti':
      case 'light':
      case 'royal':
      case 'pink':
        return 'text-light-haiti';
      case 'default':
      default:
        return 'text-current';
    }
  };

  const iconClass = (theme) => {
    switch (theme) {
      case 'haiti':
        return 'bg-athens-gray text-haiti';
      case 'light':
        return 'bg-faded-cornflower text-cornflower';
      case 'purple':
        return 'bg-bunting text-cornflower';
      case 'royal':
        return 'bg-zumthor text-royal-blue';
      case 'pink':
        return 'bg-lavender-blush text-rose';
      case 'default':
      default:
        return 'bg-transparent text-cornflower';
    }
  };

  const ctaClass = (theme) => {
    switch (theme) {
      case 'haiti':
        return 'text-haiti';
      case 'royal':
        return 'text-royal-blue';
      case 'pink':
        return 'text-rose';
      case 'light':
      case 'purple':
      case 'default':
      default:
        return 'text-cornflower';
    }
  };

  const getComponent = (direction) => {
    switch (direction) {
      case 'column':
      default:
        return (
          <USPCardColumn
            {...props}
            iconClass={iconClass(theme)}
            textClass={textClass(theme)}
            ctaClass={ctaClass(theme)}
          />
        );
      case 'row':
        return (
          <USPCardRow
            {...props}
            iconClass={iconClass(theme)}
            textClass={textClass(theme)}
            ctaClass={ctaClass(theme)}
          />
        );
    }
  };

  return getComponent(direction);
};

export default USPCardRedesigned;
